<template>
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
    <z-page title="Tambah Tangki Nitrogen" >
      <Lamanform :id="id"/>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Lamanform from './Lamanform.vue';

export default {
  extends: ZResource,
  components: {
    Lamanform,
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {
      resourceurl: this.api_service + "tangki",
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Tangki Nitrogen', route: '/tangki' },
        { label: 'Tambah', route: '/tangki/'+this.id },
      ],
      data : {id : 0},
      attahecment : [],
      slides : [],
      activeTab : 0,
      form: []
    }
  },
  methods: {
   getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'tangki/show/'+this.id, {}).then(res => {
          this.form = res

        })
      }
    },
  },
  watch: {

  },
  mounted() {
    this.getData();
    
  },
}
</script>
